/* VITALIX: Größenabfrage auf Desktop über den Produkten */
(() => {
  'use strict';

  if (window.__vitalixSizeLayout) return;
  window.__vitalixSizeLayout = true;

  const desktop = window.matchMedia('(min-width: 1024px)');
  let state;

  const style = document.createElement('style');
  style.textContent = `
    .facets-vertical > .vitalix-size-column {
      flex: 1 1 0%;
      min-width: 0;
    }

    .vitalix-size-column > #ProductGridContainer {
      width: 100% !important;
      max-width: none !important;
      min-width: 0;
    }

    .vitalix-size-column > .vitalix-size-section {
      width: 100%;
      margin: 0 0 24px !important;
      padding: 0 !important;
    }
  `;
  document.head.appendChild(style);

  function sync() {
    if (!state) return;

    const picker =
      state.host.shadowRoot?.querySelector('.ic-size-picker');

    if (!picker) return;

    const key = (picker.dataset.filterKey || '').trim();
    if (!key) return;

    const params = new URLSearchParams(location.search);
    const active = params
      .getAll(key)
      .map(value => value.trim().toLowerCase());

    const labels = [];

    picker.querySelectorAll('[data-size-value]').forEach(link => {
      const value = link.dataset.sizeValue.trim();
      const selected = active.includes(value.toLowerCase());

      if (selected) {
        link.setAttribute('aria-current', 'true');
        labels.push(link.dataset.sizeLabel || value);
      } else {
        link.removeAttribute('aria-current');
      }

      const next = new URLSearchParams(params);
      next.delete(key);
      next.append(key, value);
      next.set('filter.v.availability', '1');
      next.delete('page');

      link.setAttribute(
        'href',
        location.pathname + '?' + next.toString()
      );
    });

    const status = picker.querySelector('[data-size-status]');
    if (!status) return;

    status.dataset.state = labels.length ? 'visible' : 'hidden';

    status
      .querySelectorAll('[data-size-status-value]')
      .forEach(element => {
        element.textContent = labels.join(', ');
      });

    const reset = new URLSearchParams(params);
    reset.delete(key);
    reset.delete('page');

    const query = reset.toString();

    status.querySelectorAll('[data-size-reset]').forEach(link => {
      link.setAttribute(
        'href',
        location.pathname + (query ? '?' + query : '')
      );
    });
  }

  function position() {
    if (!state) return;

    const { source, grid, marker } = state;

    if (desktop.matches && !state.column) {
      const column = document.createElement('div');
      column.className =
        'product-grid-container vitalix-size-column';

      grid.before(column);
      source.classList.add('vitalix-size-section');
      column.append(source, grid);

      state.column = column;
    } else if (!desktop.matches && state.column) {
      marker.after(source);
      source.classList.remove('vitalix-size-section');

      state.column.before(grid);
      state.column.remove();
      state.column = null;
    }
  }

  function cleanup() {
    if (!state) return;

    state.observer.disconnect();

    if (state.marker.isConnected && state.source.isConnected) {
      state.marker.after(state.source);
    }

    state.source.classList.remove('vitalix-size-section');

    if (state.column?.isConnected) {
      if (state.grid.isConnected) {
        state.column.before(state.grid);
      }
      state.column.remove();
    }

    state.marker.remove();
    state = null;
  }

  function init() {
    if (
      state &&
      state.source.isConnected &&
      state.grid.isConnected
    ) {
      position();
      sync();
      return;
    }

    cleanup();

    if (
      !/\/collections\/[^/]+/.test(location.pathname) ||
      /\/products\//.test(location.pathname)
    ) {
      return;
    }

   const instant = document.querySelector(
  '[data-instant-id="Ew0eKtxI8yVjfNdq"], [data-instant-id="jLqdtzHn2jNWBcjH"]'
);

    const source = instant?.closest(
      '[id^="shopify-section-"]'
    );

    const host = instant?.querySelector('instant-layout');
    const grid = document.getElementById('ProductGridContainer');

    if (
      !source ||
      !host ||
      !grid ||
      !grid.parentElement.classList.contains('facets-vertical')
    ) {
      return;
    }

    if (!host.shadowRoot?.querySelector('.ic-size-picker')) {
      return;
    }

    const marker = document.createComment(
      'VITALIX original size section position'
    );

    source.before(marker);

    const observer = new MutationObserver(sync);

    state = {
      source,
      host,
      grid,
      marker,
      observer,
      column: null
    };

    observer.observe(grid, {
      childList: true,
      subtree: true
    });

    position();
    sync();
  }

  desktop.addEventListener('change', position);

  window.addEventListener('popstate', () => {
    setTimeout(sync, 0);
  });

  window.addEventListener('pageshow', init);

  document.addEventListener('shopify:section:unload', event => {
    if (
      state &&
      (
        event.target.contains(state.source) ||
        event.target.contains(state.grid)
      )
    ) {
      cleanup();
    }
  });

  document.addEventListener('shopify:section:load', () => {
    setTimeout(init, 0);
  });

  function boot() {
    init();

    let attempts = 0;

    const timer = setInterval(() => {
      init();

      if (state || ++attempts >= 20) {
        clearInterval(timer);
      }
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, {
      once: true
    });
  } else {
    boot();
  }
})();